import axios from "axios";

export default function ReceiptSendService(receiptId, formData) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/receipt/" + receiptId + "/notify/new",
    data: formData,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
